<div class="container-fluid">
  <h4>{{'Communications.Scheduler.header' | translate}}</h4>
  <p>{{'Communications.Scheduler.shortDescriptionP1' | translate}}</p>
  <div class="row mt-4">
    <mat-form-field class="col-lg-11 col-md-10 col-sm-9">
      <mat-label>{{'Communications.Scheduler.lblSelectSchedule' | translate}}</mat-label>
      <mat-select>
        @for (schedule of schedules; track schedule) {
        <mat-option [value]="schedule.id" (click)="OnChangeSchedule(schedule.id)">
          {{schedule.value}}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <div class="col-lg-1 col-md-2 col-sm-3 col-12">
      @if (service.currentUser.isReadOnly === false) {
      <button class="matbtnNew" mat-raised-button (click)="OnCreateSchedule()">{{ 'btnNew' | translate }}</button>
      }
    </div>
  </div>
  @if (isSelected) {
  <div [@slider]="isSelected? 'show' : null" class="slider">
    <div>
      <mat-form-field class="col-12">
        <mat-label>{{'Communications.Scheduler.lblName' | translate}}</mat-label>
        <input matInput [(ngModel)]="selectedSchedule.name" [ngModelOptions]="{standalone: true}" maxlength="200" />
      </mat-form-field>
      <mat-form-field class="col-12">
        <mat-label>{{'Communications.Scheduler.lblSelectFrom' | translate}}</mat-label>
        <mat-select [(ngModel)]="selectedSchedule.senderId" [ngModelOptions]="{standalone: true}">
          @for (sender of senderlist; track sender) {
          <mat-option [value]="sender.id">
            {{sender.value}}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="col-12">
        <mat-label>{{'Communications.Scheduler.lblSubject' | translate}}</mat-label>
        <input matInput [(ngModel)]="selectedSchedule.subject" [ngModelOptions]="{standalone: true}" maxlength="255" />
      </mat-form-field>
      <mat-tab-group dynamicHeight mat-align-tabs="start" mat-stretch-tabs="false" animationDuration="1000ms">
        <mat-tab label="{{'Communications.Scheduler.lblContent' | translate}}">
          <div class="row">
            <div class="col-9">
              <jodit-editor [config]="joditConfig" [(content)]="selectedSchedule.content" (contentChange)="onContentChange($event)"></jodit-editor>
            </div>
            <div class="scrollable col-3" style="background-color: white;">
              <div style="padding: 5px">
                <h5>Place Holders</h5>
                <h6>User Details</h6>
                <ul class="PlaceHolders">
                  <li class="ListItem">
                    <input type="text" value="[USER:USERNAME]" readonly="readonly" onmouseover="this.select()" title="Displays the users username" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[USER:FIRSTNAME]" readonly="readonly" onmouseover="this.select()" title="Displays the users first name" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[USER:LASTNAME]" readonly="readonly" onmouseover="this.select()" title="Displays the users last name" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[USER:ORGANISATION]" readonly="readonly" onmouseover="this.select()" title="Displays the users organisation name" />
                  </li>
                </ul>
                <h6>Market Details</h6>
                <ul class="PlaceHolders">
                  <li class="ListItem">
                    <input type="text" value="[MARKET:CODE]" readonly="readonly" onmouseover="this.select()" title="Displays the code name for the market" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[MARKET:DESCRIPTION]" readonly="readonly" onmouseover="this.select()" title="Displays the description for the market" />
                  </li>
                </ul>
                <h6>Contributor Details</h6>
                <ul class="PlaceHolders">
                  <li class="ListItem">
                    <input type="text" value="[CONTRIBUTOR:NAME]" readonly="readonly" onmouseover="this.select()" title="Displays the name of the user who contributed or assessed the rates" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CONTRIBUTOR:ORGANISATION]" readonly="readonly" onmouseover="this.select()" title="Displays the name of the organisation of the user who contributed or assessed the rates" />
                  </li>
                </ul>
                <h6>Operator Details</h6>
                <ul class="PlaceHolders">
                  <li class="ListItem">
                    <input type="text" value="[OPERATOR:NAME]" readonly="readonly" onmouseover="this.select()" title="Displays the name of the operator who contributed the rates" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[OPERATOR:ORGANISATION]" readonly="readonly" onmouseover="this.select()" title="Displays the name of the organisation of the operator who contributed the rates" />
                  </li>
                </ul>
                <h6>Post Calculation Details</h6>
                <ul class="PlaceHolders">
                  <li class="ListItem">
                    <input type="text" value="[CALC:DATE]" readonly="readonly" onmouseover="this.select()" title="Displays the date that the market was calculated" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:TIME]" readonly="readonly" onmouseover="this.select()" title="Displays the time that the market was calculated" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:VALUEDATE]" readonly="readonly" onmouseover="this.select()" title="Displays following business date that the market was calculated for" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:EXTENSION]" readonly="readonly" onmouseover="this.select()" title="Displays the number of minutes that the market was extended at the time it was calculated" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:QUORUM]" readonly="readonly" onmouseover="this.select()" title="Displays 'True' if the market reached quorum, otherwise 'False'" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:RATE]" readonly="readonly" onmouseover="this.select()" title="The calculated mean excluding outliers rate" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:WAV]" readonly="readonly" onmouseover="this.select()" title="The calculated volume weighted average" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:VOLUME]" readonly="readonly" onmouseover="this.select()" title="The calculated total volume" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:PARTICIPANTS]" readonly="readonly" onmouseover="this.select()" title="Displays the number of contributors that participated in the market" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:NONPARTICIPANTS]" readonly="readonly" onmouseover="this.select()" title="Displays the number of contributors that didn't participated in the market" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:CONTRIBUTORS]" readonly="readonly" onmouseover="this.select()" title="Displays number of contributors that can contribute to the market" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:ASSISTED]" readonly="readonly" onmouseover="this.select()" title="Displays 'True' if one or more contributors was assisted by an operator, othwewise 'False'" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:DISCARDED]" readonly="readonly" onmouseover="this.select()" title="Displays a list of contributors that have discarded rates" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:REFIX]" readonly="readonly" onmouseover="this.select()" title="Displays a list of contributors that may have caused a re-fix to occur" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:CONFLICTS]" readonly="readonly" onmouseover="this.select()" title="Displays 'True' if one or more contributors approved their own rates, otherwise 'False'" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:FAIL:STATIC]" readonly="readonly" onmouseover="this.select()" title="Displays a list of all contributors that failed the static test" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:FAIL:STATICALLTENORS]" readonly="readonly" onmouseover="this.select()" title="Displays a list of all contributors that failed the static test for all tenors" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:FAIL:SPIKE]" readonly="readonly" onmouseover="this.select()" title="Displays a list of contributors that failed the spike test" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:FAIL:D1SPIKE]" readonly="readonly" onmouseover="this.select()" title="Displays a list of contributors that failed the D1 spike test" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:FAIL:DYNAMICSPIKE]" readonly="readonly" onmouseover="this.select()" title="Displays a list of contributors that failed the dynamic spike test" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:FAIL:RELATIVEMOVEMENT]" readonly="readonly" onmouseover="this.select()" title="Displays 'True' if one or more contributors failed the relative movement test, otherwise 'False'" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:FAIL:RELATIVERATECONSISTENCY]" readonly="readonly" onmouseover="this.select()" title="Displays 'True' if one or more contributors failed the relative rate consistency test, otherwise 'False'" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:FAIL:VOLUMESUFFICIENCY]" readonly="readonly" onmouseover="this.select()" title="Displays 'True' if one or more contributors failed the volume sufficiency test, otherwise 'False'" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:HIGH:VOLUMES]" readonly="readonly" onmouseover="this.select()" title="Displays number of high volumes for the market" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:HIGH:VOLUMEMOVEMENTS]" readonly="readonly" onmouseover="this.select()" title="Displays number of high volume movements for the market" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:HIGH:STATICMOVEMENTS]" readonly="readonly" onmouseover="this.select()" title="Displays number of high static movements for the market" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:HIGH:MROMOVEMENTS]" readonly="readonly" onmouseover="this.select()" title="Displays number of high MRO movements for the market" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:HIGH:OUTLIERS]" readonly="readonly" onmouseover="this.select()" title="Displays number of high outliers for the market" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:LOW:VOLUMEMOVEMENTS]" readonly="readonly" onmouseover="this.select()" title="Displays number of low volume movements for the market" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:LOW:STATICMOVEMENTS]" readonly="readonly" onmouseover="this.select()" title="Displays number of low static movements for the market" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:LOW:MROMOVEMENTS]" readonly="readonly" onmouseover="this.select()" title="Displays number of low MRO movements for the market" />
                  </li>
                  <li class="ListItem">
                    <input type="text" value="[CALC:LOW:OUTLIERS]" readonly="readonly" onmouseover="this.select()" title="Displays number of low outliers for the market" />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="{{'Communications.Scheduler.lblRecipients' | translate}}">
          <div class="">
            <div style="height: 100%; font-size: small;">
              <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
                <!-- This is the tree node template for leaf nodes -->
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                  <li class="mat-tree-node">
                    <!-- use a disabled button to provide padding for tree leaf -->
                    <button mat-icon-button><mat-icon>{{ node.maticon }}</mat-icon></button>
                    <mat-checkbox color="primary" #ckbx [(ngModel)]="node.checked" [ngModelOptions]="{standalone: true}" (change)="OnClickRecipient(node.id, ckbx.checked)">{{ node.name }}</mat-checkbox>
                  </li>
                </mat-tree-node>
                <!-- This is the tree node template for expandable nodes -->
                <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                  <li>
                    <div class="mat-tree-node">
                      <button mat-icon-button><mat-icon>{{ node.maticon }}</mat-icon></button>
                      <mat-label class="clickable" matTreeNodeToggle> {{ node.name }}</mat-label>
                      <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                        <mat-icon class="mat-icon-rtl-mirror">
                          {{ treeControl.isExpanded(node) ? "expand_less" : "expand_more" }}
                        </mat-icon>
                      </button>
                    </div>
                    <ul [@slider]="treeControl.isExpanded(node) ? 'show' : null">
                      <ng-container matTreeNodeOutlet></ng-container>
                    </ul>
                  </li>
                </mat-nested-tree-node>
              </mat-tree>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="{{'Communications.Scheduler.lblProperties' | translate}}">
          <div class="">
            <mat-form-field class="col-12">
              <mat-label>{{'Communications.Scheduler.lblTrigger' | translate}}</mat-label>
              <mat-select [(ngModel)]="selectedSchedule.triggerId" [ngModelOptions]="{standalone: true}">
                @for (trigger of triggerlist; track trigger) {
                <mat-option [value]="trigger.id" (click)="onChangeTrigger()">
                  {{trigger.value}}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="col-12">
              <mat-label>{{'Communications.Scheduler.lblMarkets' | translate}}</mat-label>
              <mat-select multiple [(ngModel)]="selectedSchedule.marketIds" [ngModelOptions]="{standalone: true}">
                @for (market of marketlist; track market) {
                <mat-option [value]="market.id">
                  {{market.value}}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (enabledSpreadsheets) {
            <mat-form-field class="col-12">
              <mat-label>{{'Communications.Scheduler.lblAttachments' | translate}}</mat-label>
              <mat-select multiple [(ngModel)]="selectedSchedule.attachmentIds" [ngModelOptions]="{standalone: true}">
                @for (attachment of attachmentlist; track attachment) {
                <mat-option [value]="attachment.id">
                  {{attachment.value}}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            }
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
    @if (service.currentUser.isReadOnly === false) {
    <div class="mt-2">
      <button mat-raised-button style="float: right; margin-left: 10px;" color="primary" type="button" (click)="OnSaveClick()">{{'btnSave' | translate}}</button>
      <button [disabled]="service.currentUser.userRole === operatorRoleName" mat-raised-button style="float: right;" color="secondary" type="button" (click)="OnDeleteClick()">{{'btnDelete' | translate}}</button>
    </div>
    }
  </div>
  }
</div>
